/**
 * BEM class names for the standard dashboard data table (Meta Ads campaign table design).
 * Use these instead of string literals so styling stays consistent.
 */
export const dashboardDataTable = {
  panel: "dashboard-data-table-panel",
  panelHeader: "dashboard-data-table-panel__header",
  search: "dashboard-data-table-panel__search",
  /** Modifier — use with `search`: `${search} ${searchSmall}` */
  searchSmall: "dashboard-data-table-panel__search--small",
  emptyState: "dashboard-data-table__empty-state",
  emptyStateTitle: "dashboard-data-table__empty-state-title",
  emptyStateDescription: "dashboard-data-table__empty-state-description",
  /** Bordered / shadow shell when not using `panel` (e.g. table block inside another card) */
  card: "dashboard-data-table-card",
  /** Inside a parent that already provides radius/shadow (e.g. CLTV analytics shell) */
  cardNested: "dashboard-data-table-card--nested",
  scroll: "dashboard-data-table-scroll",
  table: "dashboard-data-table",
  /** Use in narrow cards (e.g. overview widgets) — drops the default 980px min-width */
  tableCompact: "dashboard-data-table--compact",
  /**
   * Alternate thead (grey strip, slightly taller rows). Prefer the default `table`
   * (Meta / Paid Media) for new work; use blueprint only when matching legacy mocks.
   */
  tableBlueprint: "dashboard-data-table--blueprint",
  /** Optional: ~8px radius on the card shell to match blueprint mockups */
  cardBlueprint: "dashboard-data-table-card--blueprint",
  sort: "dashboard-data-table__sort",
  /**
   * Wrapper for a header cell that pairs a label / sort button with a
   * `DefinitionTooltip`. Needed because the two are inline siblings otherwise
   * and baseline-align to visibly different heights.
   */
  thHelpRow: "dashboard-data-table__th-help-row",
  /** Right-aligned numeric columns */
  number: "dashboard-data-table__number",
  /** Centered header / cell (dates, metrics) */
  thCenter: "dashboard-data-table__th--center",
  tdCenter: "dashboard-data-table__td--center",
  /** Primary label column (e.g. campaign name) — bold */
  cellEmphasis: "dashboard-data-table__cell--emphasis",
  /** Missing / null display — muted em dash */
  empty: "dashboard-data-table__empty",
  metric: "dashboard-data-table__metric",
  metricSuccess: "dashboard-data-table__metric--success",
  metricWarning: "dashboard-data-table__metric--warning",
  metricDanger: "dashboard-data-table__metric--danger",
} as const;

export type DashboardDataTableClassKey = keyof typeof dashboardDataTable;
